/************************************************************************
 ** IBM Confidential
 **
 ** IBM Business Analytics: Rapidly Adaptive Visualization Engine
 **
 ** (C) Copyright IBM Corp. 2020
 **
 ** The source code for this program is not published or otherwise divested of its trade secrets, 
 ** irrespective of what has been deposited with the U.S. Copyright Office.
 ************************************************************************/
// GENERATED
import PhysicalObjectType from './PhysicalObjectType';
import MoserObject from './MoserObject';
//@import com/ibm/bi/platform/moser/common/generated/metadata/PhysicalObjectType (loadtime) // superclass
//@import com/ibm/bi/platform/moser/common/generated/metadata/MoserObject (static) // fromJSONHelper

/**
 * <p>Java class for anonymous complex type. <p>The following schema fragment specifies the expected content contained within this class. <pre> &lt;complexType&gt; &lt;complexContent&gt; &lt;extension base="{}physicalObjectType"&gt; &lt;sequence&gt; &lt;element name="datatype" type="{http://www.w3.org/2001/XMLSchema}string" minOccurs="0"/&gt; &lt;element name="nullable" type="{http://www.w3.org/2001/XMLSchema}boolean" minOccurs="0"/&gt; &lt;element name="vendorType" type="{http://www.w3.org/2001/XMLSchema}string" minOccurs="0"/&gt; &lt;element name="vendorFormat" type="{http://www.w3.org/2001/XMLSchema}string" minOccurs="0"/&gt; &lt;/sequence&gt; &lt;/extension&gt; &lt;/complexContent&gt; &lt;/complexType&gt; </pre>
 */
export default class Column extends PhysicalObjectType{

	datatype = null;

	nullable = null;

	vendorType = null;

	vendorFormat = null;



	/**
	 * Gets the value of the datatype property.
	 * @return {String} possible object is {@link String}
	 */
	getDatatype() {
		return this.datatype;
	}

	/**
	 * Sets the value of the datatype property.
	 * @param {String} value allowed object is {@link String}
	 */
	setDatatype(value) {
		var oldValue = this.datatype;
		this.datatype = value;
		this._setAndNotify(64, oldValue, value, false, false);
	}

	/**
	 * Gets the value of the nullable property.
	 * @return {Boolean} possible object is {@link Boolean}
	 */
	isNullable() {
		return this.nullable;
	}

	/**
	 * Sets the value of the nullable property.
	 * @param {Boolean} value allowed object is {@link Boolean}
	 */
	setNullable(value) {
		var oldValue = this.nullable;
		this.nullable = value;
		this._setAndNotify(74, oldValue, value, false, false);
	}

	/**
	 * Gets the value of the vendorType property.
	 * @return {String} possible object is {@link String}
	 */
	getVendorType() {
		return this.vendorType;
	}

	/**
	 * Sets the value of the vendorType property.
	 * @param {String} value allowed object is {@link String}
	 */
	setVendorType(value) {
		var oldValue = this.vendorType;
		this.vendorType = value;
		this._setAndNotify(176, oldValue, value, false, false);
	}

	/**
	 * Gets the value of the vendorFormat property.
	 * @return {String} possible object is {@link String}
	 */
	getVendorFormat() {
		return this.vendorFormat;
	}

	/**
	 * Sets the value of the vendorFormat property.
	 * @param {String} value allowed object is {@link String}
	 */
	setVendorFormat(value) {
		var oldValue = this.vendorFormat;
		this.vendorFormat = value;
		this._setAndNotify(177, oldValue, value, false, false);
	}

	/**
	 * Creates a new instance of <code>Column</code> object from JSON data.
	 * @param {ObjectFactory} factory <code>ObjectFactory</> object for object creation.
	 * @param {Object} json JSON data to be used to create the <code> Column</code> object from.
	 * @return {Column} an object of type <code>Column</code>
	 */
	static fromJSON(json, factory) {
		var result = factory.createColumn();
		var featureList = result.getFeatureList(factory);
		MoserObject.fromJSONHelper(result, featureList, json, factory);
		return result;
	}

	/**
	 * Retrieves the type of this object
	 * @return {String} the object type in a <code>String</code>
	 */
	getObjectType() {
		return "Column";
	}

	/**
	 * Get a list of FeatureObjects
	 * @return {Array} A list of FeatureObjects
	 */
	getFeatureList(factory) {
		var featureList = [];
		featureList.push(this.createFeature(false, false, false, 64, "datatype", null));
		featureList.push(this.createFeature(false, false, false, 74, "nullable", null));
		featureList.push(this.createFeature(false, false, false, 176, "vendorType", null));
		featureList.push(this.createFeature(false, false, false, 177, "vendorFormat", null));
		Array.prototype.push.apply(featureList, super.getFeatureList(factory));
		return featureList;
	}

	/**
	 * Set the value of a specific feature.
	 * @param {BaseMoserObject} value the value to set
	 * @param {int} featureID the feature id of the attribute to be set
	 */
	set(featureID, value) {
		switch (featureID) {
		case 176:
			this.setVendorType((value));
			break;
		case 177:
			this.setVendorFormat((value));
			break;
		case 74:
			this.setNullable((value));
			break;
		case 64:
			this.setDatatype((value));
			break;
		default:
			super.set(featureID, value);
		}
	}

	/**
	 * Get the value of a specific feature.
	 * @param {int} featureID the feature id of the attribute to get
	 */
	get(featureID) {
		switch (featureID) {
		case 176:
			return this.getVendorType();
		case 177:
			return this.getVendorFormat();
		case 74:
			return this.isNullable();
		case 64:
			return this.getDatatype();
		default:
			return super.get(featureID);
		}
	}

	/**
	 * Get the value of a specific feature.
	 * @param {int} featureID the feature id of the attribute to get
	 */
	basicGet(featureID) {
		switch (featureID) {
		case 176:
			return this.getVendorType();
		case 177:
			return this.getVendorFormat();
		case 74:
			return this.isNullable();
		case 64:
			return this.getDatatype();
		default:
			return super.basicGet(featureID);
		}
	}
}


// WEBPACK FOOTER //
// ./src/generated/Column.js